import {useCustomQuery} from '@salesforce/commerce-sdk-react'

const useBlogData = (ids, filters) => {
    return useCustomQuery({
        options: {
            method: 'GET',
            customApiPathParameters: {
                apiName: 'get-content',
                apiVersion: 'v1',
                endpointPath: 'getBlogArticles'
            },
            parameters: {
                ...(ids && ids !== 'cavenders-ranch' && {c_folderId: ids}),
                ...(filters && {
                    c_start: filters?.offset || 0,
                    c_size: filters?.limit || 10,
                    c_srule: filters?.sort || 'newest'
                })
            }
        }
    })
}

export default useBlogData
